import React, { useState, useRef, useEffect } from "react";
import { pb4y as api } from "../../../../services/apis";
import { producaov2 as api2 } from "../../../../services/apis";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/CKEditorFull";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import {
  Container,
  Content,
  Title,
  LabelTitle,
  Label,
  Image,
  Field,
  Div,
  Div2,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const EditarPocket = (props) => {
  const lingua = props.match.params.lingua;
  const id = props.match.params.id;
  const [loading, setLoading] = useState(true);
  const [selectedFileHorizontal, setSelectedFileHorizontal] = useState("");
  const [selectedFileVertical, setSelectedFileVertical] = useState("");
  const [segmentos, setSegmentos] = useState([]);
  const [checkboxes, setCheckboxes] = useState([]);
  const text = useRef("");
  const imagem = useRef({
    horizontal: "",
    vertical: "",
  });
  const [pocket, setPocket] = useState({});

  const optionBoolean = [
    { id: 0, text: "não" },
    { id: 1, text: "sim" },
  ];
  const optionsSelect = [
    { id: "BR", text: "BR" },
    { id: "EN", text: "EN" },
    { id: "ES", text: "ES" },
    { id: "DE", text: "DE" },
    { id: "RU", text: "RU" },
    { id: "ZH", text: "ZH" },
    { id: "FR", text: "FR" },
    { id: "IT", text: "IT" },
  ];
  useEffect(() => {
    loadAuth();
    loadSegments();
    loadPocket();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadSegments = async () => {
    await api
      .get(`segments`)
      .then((res) => {
        setSegmentos(res.data);
      })
      .catch((err) => swal("Ops! ocorreu um erro nos segmentos", err, "error"));
  };

  const loadPocket = async () => {
    await api
      .get(`pocketbooks/filter?lang=${lingua}&book=${id}`)
      .then(async (res) => {
        let logs = {
          local: "PocketBook",
          texto: `listou o artigo de id=${id}`,
        };
        await api2.post("system_logs", { acao: JSON.stringify(logs) });
        setPocket(...res.data);
        setCheckboxes(JSON.parse(res.data[0].classe_book));
        imagem.current["horizontal"] = res.data[0].imagem2;
        imagem.current["vertical"] = res.data[0].imagem;
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os valores", err, "error");
        setLoading(false);
      });
  };

  const update = async () => {
    if (selectedFileHorizontal != "") {
      await uploadImageHorizontal();
    }
    if (selectedFileVertical != "") {
      await uploadImageVertical();
    }
    console.log("resposta", checkboxes);
    const payload = {
      titulo: pocket.titulo,
      subtitulo: pocket.subtitulo,
      conteudo: text.current,
      linguagem: pocket.linguagem,
      url: pocket.url,
      classe_book: JSON.stringify(checkboxes),
      imagem2: imagem.current.horizontal,
      imagem: imagem.current.vertical,
      mais_vendidos: pocket.mais_vendidos,
      melhor_avaliado: pocket.melhor_avaliado,
      recomendado: pocket.recomendado,
      titulo_google: pocket.titulo_google,
      meta_descricao: pocket.meta_descricao,
      vts_sound: pocket.vts_sound,
      vts_aws: pocket.vts_aws,
      buy_link: pocket.buy_link,
      buy_image: pocket.buy_image,
      ativo: pocket.ativo,
      pdf: pocket.pdf,
    };

    const pocketValidation = await yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      subtitulo: yup
        .string("Necessário que informe o subtitulo")
        .required("Necessário que informe o subtitulo"),
      conteudo: yup
        .string("Necessário que informe o texto")
        .required("Necessário que informe o texto"),
      meta_descricao: yup
        .string("Necessário que informe o meta descrição")
        .required("Necessário que informe o meta descrição"),
      url: yup
        .string("Necessário que informe a url")
        .required("Necessário que informe a url"),
    });

    try {
      await pocketValidation.validate(payload, { abortEarly: true });
      api
        .put(`pocketbooks/update/${id}`, payload)
        .then(async (res) => {
          let logs = {
            local: "PocketBook",
            texto: `editou o artigo de id=${id}`,
          };
          await api2.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Artigo modificado com sucesso", "", "success").then((res) =>
            props.history.push("/admin/blog/pocketbook4you")
          );
        })
        .catch((err) => {
          swal("Não foi possível modificar o pocket", err, "").then((res) =>
            props.history.push("/admin/blog/pocketbook4you")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };
  const uploadImageHorizontal = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileHorizontal);
      inputData.append("path", `pocketbook4you/Artigos`);

      await api
        .post(`/upload`, inputData)
        .then((res) => (imagem.current["horizontal"] = res.data.url));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const uploadImageVertical = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileVertical);
      inputData.append("path", `pocketbook4you/Artigos`);

      await api
        .post(`/upload`, inputData)
        .then((res) => (imagem.current["vertical"] = res.data.url));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const modifyCheckbox = (checked, ordem) => {
    if (checked == true) {
      if (checkboxes.indexOf(`${ordem}`) == -1) {
        setCheckboxes([...checkboxes, `${ordem}`]);
      }
    }
    if (checked == false) {
      if (checkboxes.indexOf(`${ordem}`) > -1) {
        const newArray = checkboxes;
        newArray.splice(newArray.indexOf(`${ordem}`), 1);
        setCheckboxes([...newArray]);
      }
    }
  };
  const verifyImage = (tipo) => {
    if (tipo == "horizontal") {
      if (imagem.current.horizontal.indexOf("https") == -1) {
        return `https://voitto.com.br${imagem.current.horizontal}`;
      } else {
        return imagem.current.horizontal;
      }
    }
    if (tipo == "vertical") {
      if (imagem.current.vertical.indexOf("https") == -1) {
        return `https://voitto.com.br${imagem.current.vertical}`;
      } else {
        return imagem.current.vertical;
      }
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>PocketBook4You</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Linguagem</Label>
                  <select
                    value={pocket.linguagem}
                    onChange={(e) =>
                      setPocket({ ...pocket, linguagem: e.target.value })
                    }
                  >
                    {optionsSelect.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Titulo"
                  placeholder="Titulo"
                  value={pocket.titulo}
                  onChange={(e) => {
                    setPocket({ ...pocket, titulo: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Subtitulo"
                  placeholder="Subtitulo"
                  value={pocket.subtitulo}
                  onChange={(e) => {
                    setPocket({ ...pocket, subtitulo: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Titulo no Google (TAG)"
                  placeholder="Titulo no Google (TAG)"
                  value={pocket.titulo_google}
                  onChange={(e) => {
                    setPocket({ ...pocket, titulo_google: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Meta Descrição"
                  placeholder="Meta Descrição"
                  value={pocket.meta_descricao}
                  onChange={(e) => {
                    setPocket({ ...pocket, meta_descricao: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="URL"
                  placeholder="URL"
                  value={pocket.url}
                  onChange={(e) => {
                    setPocket({ ...pocket, url: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Link do PDF"
                  placeholder="Link do PDF"
                  value={pocket.pdf}
                  onChange={(e) => {
                    setPocket({ ...pocket, pdf: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="PocketCast"
                  placeholder="PocketCast"
                  value={pocket.vts_sound}
                  onChange={(e) => {
                    setPocket({ ...pocket, vts_sound: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="PocketCast - AWS"
                  placeholder="PocketCast - AWS"
                  value={pocket.vts_aws}
                  onChange={(e) => {
                    setPocket({ ...pocket, vts_aws: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Link de Compra Amazon"
                  placeholder="Link de Compra Amazon"
                  value={pocket.buy_link}
                  onChange={(e) => {
                    setPocket({ ...pocket, buy_link: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Link de Imagem Amazon"
                  placeholder="Link de Imagem Amazon"
                  value={pocket.buy_image}
                  onChange={(e) => {
                    setPocket({ ...pocket, buy_image: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Div>
                  <LabelTitle>Imagem Horizontal</LabelTitle>
                  <Div2>
                    <Field>
                      <Dropzone onFileUploaded={setSelectedFileHorizontal} />
                    </Field>
                    <Field>
                      <Image src={verifyImage("horizontal")} />
                    </Field>
                  </Div2>
                </Div>
              </Form.Group>
              <Form.Group widths="equal">
                <Div>
                  <LabelTitle>Imagem Vertical</LabelTitle>
                  <Div2>
                    <Field>
                      <Dropzone onFileUploaded={setSelectedFileVertical} />
                    </Field>
                    <Field>
                      <Image src={verifyImage("vertical")} />
                    </Field>
                  </Div2>
                </Div>
              </Form.Group>
              <Form.Group widths="equal">
                <div>
                  <LabelTitle>Segmentos:</LabelTitle>
                  <Form.Field>
                    {segmentos.map((segmento) => (
                      <Label>
                        <input
                          type="checkbox"
                          checked={
                            checkboxes.indexOf(`${segmento.ordem}`) == -1
                              ? false
                              : true
                          }
                          onClick={(e) =>
                            modifyCheckbox(e.target.checked, segmento.ordem)
                          }
                        />
                        {segmento.nome}
                      </Label>
                    ))}
                  </Form.Field>
                </div>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Texto</Label>
                  <TextEditor
                    haveFullscreen
                    default={pocket.conteudo}
                    text={text}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Mais Vendido?</Label>
                  <select
                    value={pocket.mais_vendidos}
                    onChange={(e) =>
                      setPocket({ ...pocket, mais_vendidos: e.target.value })
                    }
                  >
                    {optionBoolean.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Melhor Avaliado?</Label>
                  <select
                    value={pocket.melhor_avaliado}
                    onChange={(e) =>
                      setPocket({ ...pocket, melhor_avaliado: e.target.value })
                    }
                  >
                    {optionBoolean.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Recomendado?</Label>
                  <select
                    value={pocket.recomendado}
                    onChange={(e) =>
                      setPocket({ ...pocket, recomendado: e.target.value })
                    }
                  >
                    {optionBoolean.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Ativo?</Label>
                  <select
                    value={pocket.ativo}
                    onChange={(e) =>
                      setPocket({ ...pocket, ativo: e.target.value })
                    }
                  >
                    {optionBoolean.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <Form.Field
                  control={Button}
                  onClick={() => {
                    update();
                  }}
                >
                  Enviar
                </Form.Field>
                <Link to="/admin/blog/pocketbook4you/">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(EditarPocket);
